<template>
  <!-- List variant -->
  <div
    v-if="variant === 'list'"
    class="rounded-xl border border-gray-100 bg-white flex flex-col sm:flex-row cursor-pointer p-2.5 gap-3 hover:shadow-md transition-shadow"
    @mouseenter="$emit('highlight', property.id)"
    @mouseleave="$emit('highlight', null)"
    @click="$emit('select', property)"
  >
    <div class="relative flex-none w-full sm:w-36">
      <a :href="property.url" class="block w-full" @click.stop>
        <img :src="property.thumbnail" :alt="property.title" class="w-full h-36 sm:h-full object-cover rounded-lg" />
      </a>
      <span
        class="absolute top-2 left-2 text-white font-semibold rounded px-2 py-0.5 text-[10px] uppercase tracking-wide"
        :class="property.commercialization_type === 'rent' ? 'bg-secondary' : 'bg-primary'"
      >
        {{ property.commercialization_type === 'rent' ? labels.for_rent : labels.for_sale }}
      </span>
    </div>
    <div class="flex-1 flex flex-col justify-between min-w-0">
      <div>
        <a :href="property.url" class="block hover:underline" @click.stop>
          <h4 class="font-semibold text-sm text-primary-dark leading-snug mb-0.5 line-clamp-2">{{ property.title }}</h4>
        </a>
        <div v-if="property.location" class="flex items-center gap-1 text-gray-400 mb-1.5 text-[11px]">
          <i class="ph ph-map-pin text-xs"></i>
          <span class="truncate">{{ property.location }}</span>
        </div>
        <div class="flex items-center gap-3 text-xs text-gray-500">
          <span v-if="property.bedrooms" class="flex items-center gap-1"><i class="ph ph-bed text-primary"></i> {{ property.bedrooms }}</span>
          <span v-if="property.bathrooms" class="flex items-center gap-1"><i class="ph ph-bathtub text-primary"></i> {{ property.bathrooms }}</span>
          <span v-if="property.lot_dimensions" class="flex items-center gap-1"><i class="ph ph-ruler text-primary"></i> {{ property.lot_dimensions }}</span>
        </div>
      </div>
      <div class="flex items-center justify-between pt-2 mt-auto">
        <span v-if="property.category" class="text-[10px] text-gray-400 bg-gray-50 rounded px-1.5 py-0.5">
          {{ property.category?.name }}
        </span>
        <span
          class="text-white font-bold rounded-lg px-3 py-1 text-xs ml-auto"
          :class="property.commercialization_type === 'rent' ? 'bg-secondary' : 'bg-primary'"
        >
          {{ property.price_formatted }}
        </span>
      </div>
    </div>
  </div>

  <!-- Grid variant -->
  <div
    v-else
    class="rounded-xl overflow-hidden border border-gray-100 bg-white flex flex-col cursor-pointer hover:shadow-md transition-shadow"
    @mouseenter="$emit('highlight', property.id)"
    @mouseleave="$emit('highlight', null)"
    @click="$emit('select', property)"
  >
    <div class="relative w-full flex-none">
      <a :href="property.url" class="block w-full" @click.stop>
        <img :src="property.thumbnail" :alt="property.title" class="w-full h-36 object-cover" />
      </a>
      <span
        class="absolute top-2 left-2 text-white font-semibold rounded px-2 py-0.5 text-[10px] uppercase tracking-wide"
        :class="property.commercialization_type === 'rent' ? 'bg-secondary' : 'bg-primary'"
      >
        {{ property.commercialization_type === 'rent' ? labels.for_rent : labels.for_sale }}
      </span>
      <span
        class="absolute bottom-2 right-2 text-white font-bold rounded-lg px-3 py-1 text-xs"
        :class="property.commercialization_type === 'rent' ? 'bg-secondary' : 'bg-primary'"
      >
        {{ property.price_formatted }}
      </span>
    </div>
    <div class="w-full px-3 py-2.5 flex flex-col flex-1">
      <a :href="property.url" class="block hover:underline" @click.stop>
        <h4 class="font-semibold text-xs text-primary-dark leading-snug mb-0.5 line-clamp-2">{{ property.title }}</h4>
      </a>
      <div v-if="property.location" class="flex items-center gap-1 text-gray-400 mb-1.5 text-[11px]">
        <i class="ph ph-map-pin text-xs"></i>
        <span class="truncate">{{ property.location }}</span>
      </div>
      <div class="flex items-center gap-2 text-[11px] text-gray-500 mt-auto">
        <span v-if="property.bedrooms" class="flex items-center gap-1"><i class="ph ph-bed text-primary"></i> {{ property.bedrooms }}</span>
        <span v-if="property.bathrooms" class="flex items-center gap-1"><i class="ph ph-bathtub text-primary"></i> {{ property.bathrooms }}</span>
        <span v-if="property.lot_dimensions" class="flex items-center gap-1"><i class="ph ph-ruler text-primary"></i> {{ property.lot_dimensions }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  property: { type: Object, required: true },
  variant: { type: String, default: 'grid' }, // 'list' | 'grid'
  labels: { type: Object, required: true },
});

defineEmits(['highlight', 'select']);
</script>
